import React from "react";
import Image from "next/image";
import Link from "next/link";

const HealthcareFooter: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className=" w-full mt-0 z-10 md:pt-20 md:bg-transparent relative">
        <div className=" w-full ">
          <div className="text-center md:pb-24 md:block hidden">
            <div onClick={scrollToTop} className="cursor-pointer inline-block">
              <div className="grp_btn flex justify-start items-center w-[190px] mx-auto">
                <div className="w-[42px] min-w-[42px] h-[42px] rounded-full border-[1px] border-[#3174d6] flex justify-center items-center">
                  <Image
                    quality={50}
                    priority
                    src="/arrow_blue.png"
                    alt="business growth arrow"
                    className="new_arrow1"
                    width={26}
                    height={26}
                  />
                </div>
                <div className="out_btn poppins_regular inline-block">
                  <p className="new_perfect_btn">Scroll to top </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:container mx-auto 2xl:p-0 lg:p-0 xl:px-6 md:px-6 lg:px-6 px-5 md:block hidden">
            <div className="mx-auto w-full ">
              <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 px_5">
                <div className="lg:pt-0 lg:pb-6 pb-6 pt-4 ">
                  <div className="absolute md:bottom-[38%] md:left-[72%]">
                    <p className="2xl:text-[24px] md:text-[16px] text-black md:pl-[17px]">
                      Download the Miles One App
                    </p>
                    <div className="md:justify-end gap-4 md:flex ">
                      <div className="mt-4">
                        <div className="flex flex-col gap-4">
                          <Link
                            href="https://apps.apple.com/us/app/miles-us-pathway/id6504799221"
                            target="_blank"
                            className="flex items-center gap-2 px-2 py-2 rounded-lg bg-[#fff] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)] 2xl:w-[130px] md:w-[128px]"
                          >
                            <Image
                              src="https://ik.imagekit.io/mileseducation/miles_website/home/app-store.webp"
                              alt="App Store"
                              width={30}
                              height={30}
                              className="cursor-pointer"
                            />
                            <div className="text-black text-left leading-tight">
                              <p className="text-[10px]">Download on the</p>
                              <p className="text-[14px] font-medium">
                                App Store
                              </p>
                            </div>
                          </Link>

                          <Link
                            href="https://play.google.com/store/apps/details?id=com.miles.one"
                            target="_blank"
                            className="flex items-center gap-2 px-2 py-2 rounded-lg bg-[#fff] shadow-[99px_131px_46px_0px_rgba(4,84,175,0),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.1)] 2xl:w-[130px] md:w-[128px]"
                          >
                            <Image
                              src="https://ik.imagekit.io/mileseducation/miles_website/home/play-store.webp"
                              alt="Play Store"
                              width={30}
                              height={30}
                              className="cursor-pointer"
                            />
                            <div className="text-black text-left leading-tight">
                              <p className="text-[10px]">GET IT ON</p>
                              <p className="text-[14px] font-medium">
                                Play Store
                              </p>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-center mt-4 cursor-pointer">
                        <Image
                          src="https://ik.imagekit.io/mileseducation/miles_website/home/milesone_qr_code.webp"
                          alt="QR Code"
                          width={100}
                          height={100}
                          className="mb-1 bg-white border-[1px] border-black"
                        />
                        <p className="text-[12px] text-black">
                          Scan to download
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className=" md:justify-start flex-wrap md:flex hidden">
                    <div className="justify-between sf_regular gap-12 flex-wrap flex ">
                      <a
                        href="/about-us"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-black sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        About Us{" "}
                      </a>
                      <a
                        href="/contact-us"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-black sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Contact Us{" "}
                      </a>
                      <a
                        href="/pdf/Miles MGT.pdf"
                        target="_blank"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-black sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Annual return FY 23-24{" "}
                      </a>
                    </div>
                  </div>

                  <div className="hidden">
                    <a
                      href="#"
                      className="lg:text-base text-[14px] leading-[1.5rem] text-[#000] sf_regular underline decoration-solid mt-3 block"
                    >
                      US CPA Course
                    </a>
                  </div>
                  <div className="text-center hidden lg:mt-32 mt-10">
                    <p className="text-center pt-4 text-sm lg:w-auto w-full sf_regular text-black">
                      © 2011 - 2024 Copyright{" "}
                      <a
                        className="underline decoration-solid text-black"
                        href="https://www.mileseducation.com/"
                        target="_blank"
                      >
                        Miles Education Private Limited
                      </a>
                    </p>
                    <p className=" text-center pt-2 text-sm lg:w-auto w-full sf_regular text-black">
                      <a
                        className="underline decoration-solid text-black"
                        href="https://www.mileseducation.com/terms-and-conditions"
                        target="_blank"
                      >
                        Terms and Conditions
                      </a>
                      <span className="px-1 text-black">|</span>
                      <a
                        className="underline decoration-solid text-black"
                        href="https://www.mileseducation.com/privacy"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-right md:pb-24 md:hidden block mr-[20px] mb-[20px]">
            <Link href="#top" className="cursor-pointer inline-block">
              <Image
                quality={50}
                src="/images/business/Arrow.png"
                alt="Special Offer"
                className=""
                width={43}
                height={43}
                priority
              />
            </Link>
          </div>
          <div className="md:hidden block">
            <Image
              quality={50}
              src="/images/business/Line.png"
              alt="Footer"
              className="mx-auto"
              width={305}
              height={2}
              loading="lazy"
            />
          </div>
          <div className="lg:container md:mx-auto 2xl:p-0 lg:p-0 xl:px-10 md:px-6 md:mt-0 mt-0 lg:px-6 mx-5">
            <hr className=" border-t-[1px] border-black mx-auto mt-5 md:block hidden" />
            <div className=" flex w-full lg:py-10 md:py-8 pb-8 pt-[10px] justify-between flex-wrap items-center md:flex-row flex-col-reverse">
              <div className="flex md:flex-nowrap flex-wrap md:justify-start justify-center mt-0">
                <p className="md:text-left"></p>
                <div className="lg:text-[16px] md:text-lg text-[12px] leading-[1rem] md:order-1 order-2 text-black md:mt-0 mt-2 poppins_regular text-center lg:w-auto md:w-auto w-full">
                  <a
                    href="/terms-and-conditions"
                    className=" text-black inline-block"
                  >
                    General T&C
                  </a>
                  <span className="text-black px-2 inline-block">|</span>

                  <a href="/privacy" className=" text-black inline-block">
                    Privacy Policy
                  </a>
                  <span className="text-black px-2">|</span>
                  <a href="/cookie-policy" className="text-black inline-block">
                    Cookie Policy
                  </a>
                </div>
              </div>
              <div className="md:flex hidden items-center lg:justify-end justify-center md:order-2 order-1 lg:w-auto md:w-auto w-full lg:mt-0 md:mt-0 mt-0">
                <a
                  href="https://www.linkedin.com/school/mileseducation/"
                  target="_blank"
                  className="py-4"
                >
                  <Image
                    quality={50}
                    src="/images/accounting/linkw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[24px] brightness-0"
                    width={22}
                    height={26}
                  />
                </a>
                <a
                  href="https://www.facebook.com/Miles.Education.CPA.Review/"
                  target="_blank"
                  className="py-4"
                >
                  <Image
                    quality={50}
                    src="/images/accounting/facew.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[16px] w-[24px] brightness-0"
                    width={28}
                    height={32}
                  />
                </a>
                <a
                  href="https://www.instagram.com/miles.accounting/"
                  target="_blank"
                  className="py-4"
                >
                  <Image
                    quality={50}
                    src="/images/accounting/instaw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[24px] brightness-0"
                    width={22}
                    height={26}
                  />
                </a>
                <a
                  href="https://www.youtube.com/user/milescpareview"
                  target="_blank"
                  className="py-4"
                >
                  <Image
                    quality={50}
                    src="/images/accounting/youw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[24px] w-[24px] brightness-0"
                    width={23}
                    height={17}
                  />
                </a>
                <a
                  href="https://twitter.com/mileseducation"
                  target="_blank"
                  className="py-4"
                >
                  <Image
                    quality={50}
                    src="/images/accounting/twitw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[24px] w-[24px] brightness-0"
                    width={24}
                    height={22}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HealthcareFooter;
